import React from 'react'

import { components } from 'react-select'
import styled from 'styled-components'

import { IconProps } from '@customTypes'
import { Icon } from '_components/icon'
import { Label } from '_components/input/components'
import { palette } from '_styles/variables'

const SelectLabel = styled(Label)<{ hasIcon: boolean }>`
  line-height: 1em;

  && ~ div .centivo--select__placeholder {
    color: transparent !important;
  }

  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 5rem);
  white-space: nowrap;
  ${({ hasIcon }) => (hasIcon ? 'left: 3.125rem; ' : '')}
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.875rem;
  margin-right: 0.125rem;
`

export const getControl = ({
  float,
  displayIcon,
}: {
  float?: boolean
  displayIcon?: IconProps
}): typeof components.Control =>
  function Control({ children, ...props }) {
    const {
      selectProps: { placeholder, id },
      isFocused,
      hasValue,
    } = props
    const labelIsActive = isFocused || hasValue

    return (
      <components.Control {...props}>
        {displayIcon && (
          <IconContainer>
            <Icon
              size="1.5rem"
              color={palette.neutral['grey-icons']}
              {...displayIcon}
            />
          </IconContainer>
        )}
        {placeholder && float && (
          <SelectLabel
            label={placeholder as string}
            active={labelIsActive}
            htmlFor={id as string}
            hasIcon={!!displayIcon}
            float
          />
        )}
        {children}
      </components.Control>
    )
  }
